class ManageLateEntryReasonsController {
  constructor($uibModalInstance, $http, $rootScope, toastr, AuthenticationService, $timeout) {
    "ngInject";

    this.$uibModalInstance = $uibModalInstance;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.toastr = toastr;
    this.authenticationService = AuthenticationService;
    this.$timeout = $timeout;

    this.editingIndex = null;
    this.newReason = '';
    this.reasons = [];
  }

  $onInit() {
    // Get reasons from modalInstance (set by parent controller)
    // Use $timeout to ensure properties are set after modal initialization
    this.$timeout(() => {
      // Create a copy of the reasons array for editing
      this.reasons = angular.copy(this.$uibModalInstance.reasons || []);
    }, 0);
  }

  addReason() {
    if (!this.newReason || !this.newReason.trim()) {
      this.toastr.warning('Please enter a reason before adding.', 'Reason Required');
      return;
    }

    // Check for duplicates
    const trimmedReason = this.newReason.trim();
    const isDuplicate = this.reasons.some(reason => 
      reason.value && reason.value.trim().toLowerCase() === trimmedReason.toLowerCase()
    );

    if (isDuplicate) {
      this.toastr.warning('This reason already exists.', 'Duplicate Reason');
      return;
    }

    this.reasons.push({
      name: `Reason ${this.reasons.length + 1}`,
      value: trimmedReason
    });
    this.newReason = '';
  }

  editReason(index) {
    this.editingIndex = index;
    this.editReasonValue = this.reasons[index].value || '';
  }

  saveEdit(index) {
    if (!this.editReasonValue || !this.editReasonValue.trim()) {
      this.toastr.warning('Please enter a reason.', 'Reason Required');
      return;
    }

    const trimmedReason = this.editReasonValue.trim();
    
    // Check for duplicates (excluding current item)
    const isDuplicate = this.reasons.some((reason, idx) => 
      idx !== index && reason.value && reason.value.trim().toLowerCase() === trimmedReason.toLowerCase()
    );

    if (isDuplicate) {
      this.toastr.warning('This reason already exists.', 'Duplicate Reason');
      return;
    }

    this.reasons[index].value = trimmedReason;
    this.cancelEdit();
  }

  cancelEdit() {
    this.editingIndex = null;
    this.editReasonValue = '';
  }

  removeReason(index) {
    this.reasons.splice(index, 1);
    // Cancel edit if we're editing the removed item
    if (this.editingIndex === index) {
      this.cancelEdit();
    } else if (this.editingIndex > index) {
      // Adjust editing index if we removed an item before the one being edited
      this.editingIndex--;
    }
  }

  save() {
    const self = this;
    return this.$http.post(this.$rootScope.apiHost + "/api/users/me/entryreasons", this.reasons, { withCredentials: true })
      .then(() => this.authenticationService.refreshUser())
      .then(() => {
        this.toastr.success('Late entry reasons were updated successfully.', 'Entry Reasons Updated!');
        this.$uibModalInstance.close(true);
      })
      .catch(() => {
        this.toastr.error('Could not update your late entry reasons.', 'ERROR!');
      });
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default ManageLateEntryReasonsController;




// WEBPACK FOOTER //
// ./client/pages/profile/modals/manage-late-entry-reasons/manage-late-entry-reasons.controller.js